<template>
  <div
    :class="{'contact-location-cta--noTouch': !touch}"
    class="contact-location-cta">
    <div class="contact-location-cta__item contact-location-cta__item--contacts">
      <router-link :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }">
        <svg width="26px" height="21px" viewBox="0 0 26 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="SIMBOLI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="contact" transform="translate(-34.000000, -43.000000)" stroke="#FFFFFF">
                    <g id="Group-4">
                        <g id="Group-2" transform="translate(34.000000, 34.000000)">
                            <path d="M4.64893372,6.88348385 L7.72534243,25.9603572 L26.8022158,17.9601249 L4.64893372,6.88348385 Z" id="Rectangle-13-Copy-4" transform="translate(16.000000, 16.333570) rotate(-45.000000) translate(-16.000000, -16.333570) "></path>
                            <polyline id="Line" stroke-linecap="square" points="11.5834361 25.686086 8.20778154 29.7933779 8.20778154 23.0613435 24.0491134 10.4499262"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </router-link>
    </div>
    <div class="contact-location-cta__item contact-location-cta__item--location">
      <router-link :to="{ name: `${lang}-dove-siamo`, params: { lang } }">
        <svg width="18px" height="27px" viewBox="0 0 18 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="SIMBOLI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="contact" transform="translate(-40.000000, -139.000000)" stroke="#FFFFFF">
                  <g id="Group-4">
                      <g id="Group" transform="translate(41.000000, 139.000000)">
                          <path d="M5.5,0.819706017 L5.5,11.3546291 L15.7336719,6.08716758 L5.5,0.819706017 Z" id="Rectangle-13-Copy-2"></path>
                          <path d="M5.5,2 L5.5,25.0547382" id="Line-3" stroke-linecap="square"></path>
                          <path d="M0,26.0547382 L11,26.0547382" id="Line-3-Copy" stroke-linecap="square"></path>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    lang: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'touch'
    ])
  }
}

</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";

  .contact-location-cta{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    @media #{$large_mq} {
      flex-direction: column;
      position: fixed;
      top: 50%;
      right: 0;
      transform: translate3d(0, -50%, 0);
      z-index: 100;
    }

  }
  .contact-location-cta__item{
    background-color: #262624;
    padding: 2rem 0;
    width: 50%;
    text-align: center;
    cursor: pointer;

    @media #{$large_mq} {
      width: 80px;
      height: 80px;
      border-top: 0;
      padding: 0;

      a{
        width: 80px;
        height: 80px;
        display: block;
      }

      svg{
        top: 50%;
        transform: translate3d(0, -50%, 0);
      }

    }

    &:hover svg #FOOTER-mobile{
      stroke: #679196;
    }
  }
  .contact-location-cta__item--contacts{
    @media #{$large_mq} {
      border-left: 0;
      margin-bottom:1px;
    }
  }
  .contact-location-cta__item--location{
    @media #{$large_mq} {
      border-left: 0;
      margin-top:1px;
    }
  }
  .contact-location-cta--noTouch .contact-location-cta__item::before{
      content: "";
      position: absolute;
      left: 0; width: 100%;
      bottom: 0; height: 0;
      background-color: #679196;
      transition: height 400ms cubic-bezier(0.23, 1, 0.32, 1);
    }

    .contact-location-cta--noTouch .contact-location-cta__item:hover::before{
      height: 100%;
    }
</style>
